import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconReturn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M11.767 4.233C10.8 3.267 9.473 2.667 8 2.667 5.053 2.667 2.673 5.053 2.673 8S5.053 13.333 8 13.333c2.487 0 4.56-1.7 5.153-4h-1.386C11.22 10.887 9.74 12 8 12c-2.207 0-4-1.793-4-4s1.793-4 4-4c1.107 0 2.093.46 2.813 1.187L8.667 7.333h4.666V2.667l-1.566 1.566z"
	})
});
export default SvgIconReturn;
